import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M19 17h2l.64-2.54c.24-.959.24-1.962 0-2.92l-1.07-4.27A3 3 0 0 0 17.66 5H4a2 2 0 0 0-2 2v10h2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M14 17H9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "6.5", cy: "17.5", r: "2.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "16.5", cy: "17.5", r: "2.5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Bus";
const Bus = memo(themed(Icon));
export {
  Bus
};
//# sourceMappingURL=bus.js.map
